import React from 'react';
import DataManagementScreen from '../../src/screens/progress/DataManagementScreen';

export default function DataManagementRoute() {
  return <DataManagementScreen />;
}
